import {
  GET_ACTIVE_ZONES_BY_ORG_API_URL,
  GET_ZONE_BY_ID_API_URL,
} from '../constants/Constant';
import { IZone } from '../interfaces/IZone';

import axiosInstance from './AxiosInstance';

export const ZoneService = {
  /**
   * Fetches a single zone document by its ID.
   * @param id - The ID of the zone to fetch
   * @returns Promise containing the zone document
   */
  GetById: async (id: string): Promise<IZone> => {
    const response = await axiosInstance.get(`${GET_ZONE_BY_ID_API_URL}/${id}`);
    return response.data;
  },

  /**
   * Fetches all active zone documents for an organisation.
   * Used as the map data source — zones carry their own geoData and zoneType.
   *
   * Reads GetByOrgActive, so soft-deleted zones are excluded server-side
   * (OP-2361).
   *
   * @param orgId - The organisation ID
   * @returns Promise containing the org's active zone documents
   */
  GetByOrgActive: async (orgId: string): Promise<IZone[]> => {
    const response = await axiosInstance.get(
      `${GET_ACTIVE_ZONES_BY_ORG_API_URL}/${orgId}`,
      { _silentErrors: true }
    );
    return response.data;
  },
};

export default ZoneService;
